import { maybe } from "@saleor/misc";
import moment from "moment";

import { IFilterElement } from "../../../../components/Filter";
import {
  createFilterTabUtils,
  createFilterUtils,
  dedupeFilter,
  getGteLteVariables,
  getMinMaxQueryParam,
  getMultipleValueQueryParam
} from "../../../../utils/filters";
import {
  ProductDetailsBiFilterKeys,
  ProductDetailsBiFilterOpts
} from "../../components/ProductDetailsBiPage/filters";
import {
  ProductDetailsBiListUrlFilters,
  ProductDetailsBiListUrlFiltersEnum,
  ProductDetailsBiListUrlFiltersWithMultipleValues,
  ProductDetailsBiListUrlQueryParams
} from "../../url";
export const STORE_DETAILS_FILTERS_KEY = "ProductDetailsBiFilter";

export function getFilterOpts(
  params: ProductDetailsBiListUrlFilters
): ProductDetailsBiFilterOpts {
  return {
    productStatus: {
      active: maybe(() => params.productStatus !== undefined, false),
      value: maybe(() => dedupeFilter(params.productStatus), [])
    },
    updateDate: {
      active: maybe(
        () =>
          [params.updateFrom, params.updateTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.updateTo, ""),
        min: maybe(() => params.updateFrom, "")
      }
    }
  };
}

export function getFilterVariables(params: ProductDetailsBiListUrlFilters) {
  const newDate = new Date();
  const endDay = newDate.getDate();
  const endMonth = newDate.getMonth() + 1;
  const endYear = newDate.getFullYear();

  const startDate = moment(newDate.setMonth(newDate.getMonth() - 3)).format(
    "YYYY-MM-DD"
  );

  const endDate = moment(`${endYear}-${endMonth}-${endDay} 00:00:00`)
    .add(1, "days")
    .format("YYYY-MM-DD HH:mm:ssZZ");

  return {
    productStatus: params.productStatus || [],
    productUpdatedDate: getGteLteVariables({
      gte: params.updateFrom
        ? moment(`${params.updateFrom} 00:00:00`).format(
            "YYYY-MM-DD HH:mm:ssZZ"
          )
        : moment(`${startDate} 00:00:00`).format("YYYY-MM-DD HH:mm:ssZZ"),
      lte: params.updateTo
        ? moment(`${params.updateTo} 00:00:00`)
            .add(1, "days")
            .format("YYYY-MM-DD HH:mm:ssZZ")
        : endDate
    }),

    search: params.query
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<ProductDetailsBiFilterKeys>
): ProductDetailsBiListUrlFilters {
  const { name } = filter;

  switch (name) {
    case ProductDetailsBiFilterKeys.updateDate:
      return getMinMaxQueryParam(
        filter,
        ProductDetailsBiListUrlFiltersEnum.updateFrom,
        ProductDetailsBiListUrlFiltersEnum.updateTo
      );

    case ProductDetailsBiFilterKeys.productStatus:
      return getMultipleValueQueryParam(
        filter,
        ProductDetailsBiListUrlFiltersWithMultipleValues.productStatus
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<ProductDetailsBiListUrlFilters>(
  STORE_DETAILS_FILTERS_KEY
);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  ProductDetailsBiListUrlQueryParams,
  ProductDetailsBiListUrlFilters
>({
  ...ProductDetailsBiListUrlFiltersEnum,
  ...ProductDetailsBiListUrlFiltersWithMultipleValues
});
